export default __webpack_public_path__ + "static/media/joseph.e3fec7e6.png";